export default __webpack_public_path__ + "static/sugerencias-2828d6fc3e33dd7489d950eaad9b9f5e.jpg";